import ScrollToTop from "../../components/Layout/ScrollToTop";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from "../../components/Layout/Layout";
import Header from "../../components/Layout/Header";
import Homepage from "../../views/HomePage/Homepage";
import About from "../../views/About/About";
import Services from "../../views/services";
import Contact from "../../views/Contact/Contact";
import Blogs from "../../views/Blogs/Blogs";
import BlogDetails from "../../views/BlogDetails/BlogDetails";
import BlogDetails2 from "../../views/BlogDetails/BlogDetails2";
import BlogDetails3 from "../../views/BlogDetails/BlogDetails3";
import Register from "../../views/Register/Register";
import Teams from "../../views/Teams/Teams";
import SignIn from "../../views/SignIn/SignIn";
import ForgotPassword1 from "../../views/ForgotPassword1/ForgotPassword1";
import ForgotPassword2 from "../../views/ForgotPassword2/ForgotPassword2";
import ForgotPassword3 from "../../views/ForgotPassword3/ForgotPassword3";
import UserLayout from "../../components/UserLayout/Layout";
import RidePage from "../../views/RidePage/RidePage";
import GiftPage from "../../views/GiftPage/GiftPage";
import Wallet from "../../views/Wallet/Wallet";
import EditProfile from "../../views/EditProfile/EditProfile";
import Profile from "../../views/profile";
import Notification from "../../views/notifications/index";
import Setting from "../../views/Setting/Setting";
import Rewards from "../../views/Rewards/Rewards";
import RecentPage from "../../views/RecentPage/RecentPage";
import ShortcutPage from "../../views/ShortcutPage/ShortcutPage";
import AirportPage from "../../views/AirportPage/AirportPage";
import TransitPage from "../../views/TransitPage/TransitPage";
import ConfirmationRide from "../../views/ConfirmationRide/ConfirmationRide";
import ViewRidePage from "../../views/ViewRidePage/ViewRidePage";
import ProtectedRoute from "../../views/protectedRoute";
import Payment from "../../views/Payment";
import OngoingRide from "../../views/OngoingRide/OngoingRide";
import CheckRoute from "../../views/CheckRoute/CheckRoute";
import ChangePassword from "../../views/ChangePassword/index";
import OurModals from "../../views/ourModals";
import ChauffeurBookingLogs from "../../views/chauffeurBookingLogs";
import ChauffeurBookingDetails from "../../views/chauffeurBookingLogs/chauffeurBookingDetails";
import ChauffeurBookingcomplete from "../../views/chauffeurBookingLogs/chauffeurBookingcomplete";
import MembershipPlanLog from "../../views/membershipPlanLog";
import Membership from "../../views/membership";
import MembershipPlanDetails from "../../views/membershipPlanLog/membershipPlanDetails";
import ChauffeurBookingmember from "../../views/chauffeurBookingmember";
import PrivacyPolicy from "../../views/privacyPolicy";
import Guest from "../../views/Guest/index";
import GuestVerification from "../../views/Guest/guestVerification";
import TermsConditions from "../../views/termsConditions";
import BuySubscription from "../../views/BuySubscription";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import socket from "../socket/index";

function MyRouter() {
  const token = useSelector((state) => state.user.userToken);
  const user = useSelector((state) => state.user.userData);
  useEffect(() => {
    if (token) {
      socket.emit("setup", user);
    }
  }, []);
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <ScrollToTop />
      <Routes>
        <Route
          path="/"
          element={
            <Layout>
              <Homepage />
            </Layout>
          }
        />
        <Route
          path="/about"
          element={
            <Layout>
              <About />
            </Layout>
          }
        />
        <Route
          path="/membership"
          element={
            <Layout>
              <Membership />
            </Layout>
          }
        />
        <Route
          path="/services"
          element={
            <Layout>
              <Services />
            </Layout>
          }
        />
        <Route
          path="/privacyPolicy"
          element={
            <Layout>
              <PrivacyPolicy />
            </Layout>
          }
        />
        <Route
          path="/termsConditions"
          element={
            <Layout>
              <TermsConditions />
            </Layout>
          }
        />
        <Route
          path="/chauffeurBookingLogs"
          element={
            <ProtectedRoute>
            <Layout>
              <ChauffeurBookingLogs />
            </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/chauffeurBookingLogs/:id"
          element={
            <ProtectedRoute>

            <Layout>
              <ChauffeurBookingDetails />
            </Layout>
            </ProtectedRoute>
          }
          />
        <Route
          path="/chauffeurBookingLogs/complete/:id"
          element={
            <Layout>
              <ChauffeurBookingcomplete />
            </Layout>
          }
          />
        <Route
          path="/membershipPlanLog"
          element={
            <ProtectedRoute>

            <Layout>
              <MembershipPlanLog />
            </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/membershipPlanLog/:id"
          element={
            <ProtectedRoute>

            <Layout>
              <MembershipPlanDetails />
            </Layout>
            </ProtectedRoute>
          }
          />
        <Route
          path="/chauffeurBookingmember"
          element={
            <ProtectedRoute>

            <Layout>
              <ChauffeurBookingmember />
            </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/contact"
          element={
            <Layout>
              <Contact />
            </Layout>
          }
        />
        <Route
          path="/blogs"
          element={
            <Layout>
              <Blogs />
            </Layout>
          }
        />

        <Route
          path="/blogDetails"
          element={
            <Layout>
              <BlogDetails />
            </Layout>
          }
        />
        <Route
          path="/blogDetails2"
          element={
            <Layout>
              <BlogDetails2 />
            </Layout>
          }
        />
        <Route
          path="/blogDetails3"
          element={
            <Layout>
              <BlogDetails3 />
            </Layout>
          }
        />
        <Route
          path="/team"
          element={
            <Layout>
              <Teams />
            </Layout>
          }
        />
        <Route
          path="/viewRide"
          element={
            <ProtectedRoute>

            <Layout>
              <ViewRidePage />
            </Layout>
            </ProtectedRoute>
          }
        />
        <Route path="/register" element={<Register />} />
        <Route path="/signIn" element={<SignIn />} />
        <Route path="/guest" element={<Guest />} />
        <Route path="/guestVerification" element={<GuestVerification />} />
        <Route path="/forgotPassword" element={<ForgotPassword1 />} />
        <Route path="/forgotPassword/otp" element={<ForgotPassword2 />} />
        <Route
          path="/forgotPassword/changePassword"
          element={<ForgotPassword3 />}
        />

        {/* ------------------------------------------------------------------------------------------------------------------------------------- */}
        <Route
          path="/buySubscription"
          element={
            <ProtectedRoute>
              <Layout>
                <BuySubscription />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/payment"
          element={
            <ProtectedRoute>
              <Layout>
                <Payment />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/ride"
          element={
            <ProtectedRoute>
              <CheckRoute>
              <UserLayout>
                <RidePage />
              </UserLayout>
              </CheckRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/ride/:id"
          element={
            <ProtectedRoute>
              <UserLayout>
                <OngoingRide />
              </UserLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/recent"
          element={
            <ProtectedRoute>
            <Layout>
              <RecentPage />
            </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/ourModals"
          element={
            <Layout>
              <OurModals />
            </Layout>
          }
        />
        <Route
          path="/shortcut"
          element={
            <UserLayout>
              <ShortcutPage />
            </UserLayout>
          }
        />
        <Route
          path="/airport"
          element={
            <UserLayout>
              <AirportPage />
            </UserLayout>
          }
        />
        <Route
          path="/transit"
          element={
            <UserLayout>
              <TransitPage />
            </UserLayout>
          }
        />

        <Route
          path="/giftCard"
          element={
            <UserLayout>
              <GiftPage />
            </UserLayout>
          }
        />
        <Route
          path="/wallet"
          element={
            <UserLayout>
              <Wallet />
            </UserLayout>
          }
        />
        <Route
          path="/editProfile"
          element={
            <ProtectedRoute>

            <Layout>
              <EditProfile />
            </Layout>
            </ProtectedRoute>
          }
          />
        <Route
          path="/changePassword"
          element={
            <ProtectedRoute>
            <Layout>
              <ChangePassword />
            </Layout>
              </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
              <ProtectedRoute>

            <Layout>
              <Profile />
            </Layout>
              </ProtectedRoute>
          }
          />
        <Route
          path="/notifications"
          element={
            <ProtectedRoute>
            <Layout>
              <Notification />
            </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/setting"
          element={
            <UserLayout>
              <Setting />
            </UserLayout>
          }
        />
        <Route
          path="/rewards"
          element={
            <UserLayout>
              <Rewards />
            </UserLayout>
          }
        />
        <Route
          path="/confirmationRide"
          element={
            <UserLayout>
              <ConfirmationRide />
            </UserLayout>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default MyRouter;
